module.exports = __webpack_public_path__ + "static/media/owlonly.5e4789be.png";